module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/umd-298.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/install/umd.md
// module id = 763
// module chunks = 392